export const DateInput = (p: {
	date: string;
	setDate: (d: string) => void;
	id?: string;
}) => {
	return (
		<input
			id={p.id ?? "date-picker"}
			title={""}
			name={"date-picker"}
			className={"input"}
			type={"datetime-local"}
			value={p.date}
			onChange={(e) => p.setDate(e.currentTarget.value)}
		/>
	);
};

export function FormatDateValue(d: string): string {
	let date = d.substring(6, 10);
	date += `-${d.substring(3, 5)}`;
	date += `-${d.substring(0, 2)}`;
	const t = d.split("T")[1].split(":");
	let hours = Number(t[0]);
	if (d.includes("p") && hours < 12) {
		hours += 12;
	}
	const h = `0${hours.toString()}`;
	date += `T${h.substring(h.length - 2)}`;
	date += `:${t[1]}`;

	return date;
}
